"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const app_json_1 = require("./app.json");
const FlyWayWeb_1 = __importDefault(require("./FlyWayWeb"));
require("./i18n");
react_native_1.AppRegistry.registerComponent(app_json_1.expo.name, () => FlyWayWeb_1.default);
react_native_1.AppRegistry.runApplication(app_json_1.expo.name, {
    initialProps: {},
    rootTag: document.getElementById('app-root'),
});
